import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const userVouchers = {
  state: {
    statisticsVoucher: "",
    dataSendPhoneList: {},
    dataSendCustomerList: {},
    listUserVoucher: [],
    listVoucher: [],
    total: 0,
    count: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getListUserVoucher(payload, rootState) {
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      if (payload.to)
        payload.to = new Date(payload.to).setHours(23, 59, 59, 999);
      if (payload.from)
        payload.from = new Date(payload.from).setHours(0, 0, 0, 0);
      return fetch(
        DomainAPI + Channel + "/api/secure/userVouchers/getListUserVoucher",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            this.setState({
              listUserVoucher: result.data.list,
              listVoucher: result.data.listVoucher,
              total: result.data.total,
              count: result.data.count,
            });
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async deleteUserVoucher(payload, rootState) {
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      let data = {
        _id: payload._id,
      };
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/userVouchers/deleteUserVoucher",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async setVoucherForPhoneList(payload, rootState) {
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      let data = {
        phoneList: payload.phoneList,
        voucherSend: payload.voucherSend,
        methodSend: payload.methodSend,
      };
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/userVouchers/setVoucherForPhoneList",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async setVoucherForCustomerList(payload, rootState) {
      let phoneList = [];
      if (payload.idList.length) {
        let idList = payload.idList;
        idList.forEach((item) => {
          phoneList.push(item);
        });
      }

      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      let data = {
        phoneList: phoneList,
        voucherSend: payload.voucherSend,
        methodSend: payload.methodSend,
      };
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/userVouchers/setVoucherForPhoneList",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async checkLimitVoucher(payload, rootState) {
      const _this = this;
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/userVouchers/checkLimitVoucher",
        {
          method: "POST",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({ statisticsVoucher: result.data });
          }
          return result.code === 1 ? true : false;
        })
        .catch((err) => {
          return false;
        });
    },
    async updateTimesUserVoucher(payload, rootState) {
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/userVouchers/updateTimesUserVoucher",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
  }),
};

export default userVouchers;
